import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    dataVideoId: null
  },
  setup(__props: any) {

const props = __props as {
  dataVideoId: string
}



onMounted(() => {
  let script = document.createElement('script')
  script.setAttribute(
    'src',
    'https://players.brightcove.net/3871979161001/yOkHWgCpa_default/index.min.js'
  )
  document.head.appendChild(script)
})

return (_ctx: any,_cache: any) => {
  const _component_video_js = _resolveComponent("video-js")!

  return (_openBlock(), _createBlock(_component_video_js, {
    "data-account": "3871979161001",
    "data-player": "yOkHWgCpa",
    "data-embed": "default",
    controls: "",
    "data-video-id": props.dataVideoId,
    "data-playlist-id": "",
    "data-application-id": "",
    class: "vjs-fluid",
    "data-bc-trackingid": "%%=v(@bc_tracking_id)=%%",
    "data-bc-custom-guid": "%%=v(@bc_custom_guid)=%%"
  }, null, 8, ["data-video-id"]))
}
}

})